import type { PoolOfferConfig } from '../../lib/api/operatorConsole';

/**
 * The pack selector's value for the custom pack lab on demo data, offered when no custom pack can be picked: the
 * preview then opens the lab on fixtures instead of a game.
 */
export const LAB_DEMO_PACK = 'custom-pack-lab-demo';

/**
 * The demo entry is for internal builds (`VITE_LAB_DEMO=true`): it lets the lab be themed on fixtures before a pack
 * exists, and is not something a partner's console should advertise. Off everywhere else.
 */
export function labDemoEnabled(): boolean {
  return import.meta.env.VITE_LAB_DEMO === 'true';
}

/** No pack in the list is a custom pack: the lab can only be themed on demo data. */
export function needsLabDemo(packs: PoolOfferConfig[]): boolean {
  return !packs.some((p) => p.pool_offer_game_kind === 'custom_pack');
}

/** The pack picked in the selector is a custom pack: the lab is what the preview shows. */
export function isCustomPackPicked(packs: PoolOfferConfig[], gameId: string): boolean {
  return packs.some((p) => String(p.pool_offer_id) === gameId && p.pool_offer_game_kind === 'custom_pack');
}
